












































import {Company, ExportserviceHeaderRow} from "../../modules/models";
import {Component, Inject, Prop, Watch} from "vue-property-decorator";
import Api from "./Api";
import rn from "../../modules/vRoutedefs";
import CompanyUserRequired from "@/components/CompanyRequired";

@Component
export default class Integrations extends CompanyUserRequired {
    @Inject()
    api!: Api;

    headerRows: ExportserviceHeaderRow[] = [];

    async loadHeaderRows() {
        if(this.company != null) {
            this.headerRows = await this.api.fetchExportserviceHeaderRows(this.company.orgNum);
        }
    }

    hmsregIntegrationSettingsPageTo() {
        return {name: rn.system.integrations.hmsreg.name};
    }
    proresultIntegrationSettingsPageTo() {
        return {name: rn.system.integrations.proresult.name};
    }
    exportserviceSettingsPageTo() {
        return {name: rn.system.integrations.exportservice.name};
    }

    exportserviceDescriptions() {
        return this.headerRows.map((hr) => hr.description).join(", ");
    }

    @Watch("company", {immediate: true})
    compChanged(c: Company) {
        if(c != null) {
            this.loadHeaderRows();
        }
    }
}
